// import React, { useState, useEffect } from 'react'
// import cp from '../images/cpi.png';


// //All the svg files

// import styled from 'styled-components'


// const Container = styled.div`
//   position: fixed;
//   margin-top:-24px;
//   .active {
//     border-right: 4px solid #fff;
//     background-color: rgba(137, 171, 245, 0.37);
//     img {
//       filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg)
//         brightness(103%) contrast(103%);
//     }
//   }
// `

// const Button = styled.button`
//   background-color:#173EE2;
//   border: none;
//   width: 2.5rem;
//   height: 2.5rem;
//   border-radius: 50%;
//   margin: 0.5rem 0 0 0.5rem;
//   cursor: pointer;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   position: relative;
//  z-index:20;
//   &::before,
//   &::after {
//     content: '';
//     background-color: #fff;
//     height: 2px;
//     width: 1rem;
//     position: absolute;
//     transition: all 0.3s ease;
//   }
//   &::before {
//     top: ${props => (props.clicked ? '1.5' : '1rem')};
//     transform: ${props => (props.clicked ? 'rotate(135deg)' : 'rotate(0)')};
//   }
//   &::after {
//     top: ${props => (props.clicked ? '1.2' : '1.5rem')};
//     transform: ${props => (props.clicked ? 'rotate(-135deg)' : 'rotate(0)')};
//   }
// `

// const SidebarContainer = styled.div`
//   background-color:#FF1C01;
//   height: 100vh;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   width: 3rem;
//   position: relative;
//   position: absolute;
//   top: 0;
//   z-index: 2;
//   border-radius: 0 100px 0 0;
//   top: 4rem;

//   p {
//     color: white;
//     width:75vh;
//     text-align:center;
//     transform: rotate(-90deg);
//     font-size: 28px;
//     letter-spacing: 10px;
//     text-transform: uppercase;
//   }
// `

// const Logo = styled.div`
//   width: 3rem;
//   position:relative;
//   top: 6rem;

//   z-index: 3;
//   img {
//     width: 100%;
//     height: auto;
//   }
// `

// const SlickBar = styled.ul`
//   color: #fff;
//   list-style: none;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   background-color:#0f0e33;
//   padding: 10rem 0 8rem 2rem;
//   position: absolute;
//   left: ${props => (props.clicked ? '0' : '-5rem')};
//   width: ${props => (props.clicked ? '14rem' : '0')};
//   transition: all 0.5s ease;
//   top: 0;
//   height: 100vh;
//   overflow-y: scroll;
//   z-index: 1;
// `

// const Item = styled.a`
//   text-decoration: none;
//   color: #FF1C01;
//   width: 100%;
//   padding: 1rem 0;
//   cursor: pointer;
//   display: flex;
//   font-weight:bold;
//   font-size:1rem;
//   padding-left: 0.8rem;

//   &:hover {
//     border-right: 4px solid #FF1C01;
//     text-decoration:none;
//     color:white;
//     background-color: rgba(137, 171, 245, 0.37);
//     img {
//       filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg)
//         brightness(103%) contrast(103%);
//     }
//   }
//   img {
//     width: 1.5rem;
//     height: auto;
//     filter: invert(92%) sepia(4%) saturate(1033%) hue-rotate(169deg)
//       brightness(78%) contrast(85%);
//   }
// `

// const Text = styled.span`
//   width: ${props => (props.clicked ? '100%' : '0')};
//   overflow: hidden;
//   margin-left: ${props => (props.clicked ? '1.5rem' : '0')};
//   transition: all 0.3s ease;
// `

// const Sidebar = () => {
//   const [click, setClick] = useState(true)
//   const [width, setWindowWidth] = useState(0)
//   const handleClick = () => (width < 998)?setClick(!click):"";



//   useEffect(() => {
//     updateDimensions()

//     window.addEventListener('resize', updateDimensions)
//     return () => window.removeEventListener('resize', updateDimensions)
//   }, [])

//   const updateDimensions = () => {
//     const width = window.innerWidth
//     setWindowWidth(width)
//     if (width < 998) {
//       setClick()
//     } else {
//       setClick(true)
//     }
//   }



//   return (
//     <Container>
//       {width < 998 ? (
//         <Button clicked={click} onClick={() => handleClick()}>
//              {/* Click */}  
//         </Button>
//       ) : (
//         ''
//       )}

//       <SlickBar clicked={click}>

//         <Item exact activeClassName='active' href='/cpp-variable'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Variable</Text>
//         </Item>



//         <Item exact activeClassName='active' href='/cpp-scope-of-variable'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Scope-of-Variable</Text>
//         </Item>

//         <Item exact activeClassName='active' href='/cpp-element'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Element</Text>
//         </Item>


//         <Item exact activeClassName='active' href='/cpp-keyword'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ keyword</Text>
//         </Item>

//         <Item exact activeClassName='active' href='/cpp-identifier'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Identifier</Text>
//         </Item>

//         <Item exact activeClassName='active' href='/cpp-first-program'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ First-Program</Text>
//         </Item>






//         <Item exact activeClassName='active' href='/cpp-input'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Input</Text>
//         </Item>



//         <Item exact activeClassName='active' href='/cpp-literal'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Literal</Text>
//         </Item>

//         <Item exact activeClassName='active' href='/cpp-operator'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Operator</Text>
//         </Item>


//         <Item exact activeClassName='active' href='/cpp-control-structure'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Control-Structure</Text>
//         </Item>

//         <Item exact activeClassName='active' href='/cpp-if'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ If</Text>
//         </Item>

//         <Item exact activeClassName='active' href='/cpp-if-else'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ If-Else</Text>
//         </Item>



//         <Item exact activeClassName='active' href='/cpp-if-else-if'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ If-Else-If</Text>
//         </Item>



//         <Item exact activeClassName='active' href='/cpp-switch'>
//           <Text clicked={click} onClick={() => handleClick()} ></Text>
//         </Item>

//         <Item exact activeClassName='active' href='/cpp-looping'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Looping</Text>
//         </Item>


//         <Item exact activeClassName='active' href='/cpp-while'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ While</Text>
//         </Item>

//         <Item exact activeClassName='active' href='/cpp-do-while'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Do-While</Text>
//         </Item>

//         <Item exact activeClassName='active' href='/cpp-for-loop'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ For-Loop</Text>
//         </Item>






//         <Item exact activeClassName='active' href='/cpp-break'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Break</Text>
//         </Item>



//         <Item exact activeClassName='active' href='/cpp-continue'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Continue</Text>
//         </Item>

//         <Item exact activeClassName='active' href='/cpp-array'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Array</Text>
//         </Item>


//         <Item exact activeClassName='active' href='/cpp-function'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Function</Text>
//         </Item>

//         <Item exact activeClassName='active' href='/cpp-user-defined-function'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ User-Defined-Function</Text>
//         </Item>

//         <Item exact activeClassName='active' href='/cpp-passing-argument'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ Passing-Argument</Text>
//         </Item>


//         <Item exact activeClassName='active' href='/cpp-history'>
//           <Text clicked={click} onClick={() => handleClick()} >C++ History</Text>
//         </Item>


//       </SlickBar>







//       <Logo onClick={() => handleClick()}>
//      <img src={cp} alt="" />
//       </Logo>



//       <SidebarContainer>
//         <p>C++</p> 
//       </SidebarContainer>
//     </Container>
//   )
// }

// export default Sidebar;


import React, { useEffect, useLayoutEffect } from "react";
import { useState } from "react";

import { BsFillArrowLeftCircleFill } from "react-icons/bs";

function Sidebar() {
  let buttonns = document.querySelectorAll(".buttonn");
  console.log(buttonns);
  buttonns.forEach((buttonn) => {
    buttonn.addEventListener("click", () => {
      reset();
      buttonn.classList.add("activeBtn");
    });
  });

  function reset() {
    buttonns.forEach((btn) => btn.classList.remove("activeBtn"));
  }



  const [mobile, setmobile] = useState(false);

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }
  const [width] = useWindowSize();

  console.log(width);
  const [options, setoptions] = useState(true);

  useEffect(() => {
    if (width < 1024) {
      setmobile(true);
      setOpen(false);
      setoptions(false);
    }

    if (width > 1024) {
      setmob(false)
      setmobile(false);
      setOpen(true);
      setoptions(true);
    }
  }, [width]);
  const [sty, setsty] = useState({
    color: 'red'
  })

  const [open, setOpen] = useState(false);
  const [mob, setmob] = useState(true);
  console.log(open);
  console.log(mobile);
  console.log(mob);

  return (
    <>
      <Navbar
        open={open}
        options={options}
        setOpen={setOpen}
        mob={mob}
        setmob={setmob}
      />
      <div className="w-full mt-[8rem] lg:mt-[9rem]">
        <div className="flex text-[#0000ff] duration-500   mr-0">
          <div
            className={` ${mob === false ? "bg-[#ffff00]" : "hidden"
              } lg:bg-[#ffff00] z-10 fixed top-13 mr-72 left-0  h-full lg:w-56 w-48   flex  pt-2 lg:pt-8 flex-col rounded-tr-xl `}
          >
            <div className={`${mobile && mob ? "hidden" : "flex flex-col"}  `}>
              <button
                className={`text-gray-500    lg:w-48 h-12 w-40 my-3 flex  ml-3 bg-[#1c076c] justify-center items-center   rounded-2xl ${open ? "flex" : "hidden"
                  }`}
              >
                <h2 className="text-lg font-bold text-[#0000ff] mb-0 pl-0  text-white ">
                  C++
                </h2>
              </button>

              <div className="py-2 bb w-full flex flex-col items-center overflow-y-scroll  h-[70vh] md:h-[80vh] lg:h-[68vh]">
                <div className=" w-full border-gray-200 flex flex-col items-center">
                  <ul className=" w-full">
                    <a
                      href="/cpp-variable"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200  hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer  hover:text-white hover:bg-[#1c076c]">
                        {" "}
                        C++ Variable
                      </li>
                    </a>

                    <a
                      href="/cpp-scope-of-variable"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Scope-of-Variable
                      </li>
                    </a>
                    <a
                      href="/cpp-element"
                      className={` mb-0   text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        {" "}
                        C++ Element
                      </li>
                    </a>
                    <a
                      href="/cpp-keyword"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ keyword
                      </li>
                    </a>
                    <a
                      href="/cpp-identifier"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Identifier
                      </li>
                    </a>
                    <a
                      href="/cpp-first-program"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ First-Program
                      </li>
                    </a>
                    <a
                      href="/cpp-input"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Input
                      </li>
                    </a>
                    <a
                      href="/cpp-literal"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Literal
                      </li>
                    </a>
                    <a
                      href="/cpp-operator"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Operator
                      </li>
                    </a>
                    <a
                      href="/cpp-control-structure"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Control-Structure
                      </li>
                    </a>
                    <a
                      href="/cpp-if"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ If
                      </li>
                    </a>
                    <a
                      href="/cpp-if-else"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ If-Else
                      </li>
                    </a>
                    <a
                      href="/cpp-if-else-if"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ If-Else-If
                      </li>
                    </a>
                    <a
                      href="/cpp-switch"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Switch
                      </li>
                    </a>
                    <a
                      href="/cpp-looping"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Looping
                      </li>
                    </a>
                    <a
                      href="/cpp-while"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ While
                      </li>
                    </a>
                    <a
                      href="/cpp-do-while"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Do-While
                      </li>
                    </a>
                    <a
                      href="/cpp-for-loop"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ For-Loop
                      </li>
                    </a>
                    <a
                      href="/cpp-break"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Break
                      </li>
                    </a>
                    <a
                      href="/cpp-continue"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Continue
                      </li>
                    </a>
                    <a
                      href="/cpp-array"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Array
                      </li>
                    </a>



                    <a
                      href="/cpp-function"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Function
                      </li>
                    </a>
                    <a
                      href="/cpp-user-defined-function"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ User-Defined-Function
                      </li>
                    </a>
                    <a
                      href="/cpp-passing-argument"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ Passing-Argument
                      </li>
                    </a>


                    <a
                      href="/cpp-history"
                      className={`  mb-0  text-lg font-bold text-[#0000ff] lg:text-[14px] font-bold text-[#0000ff] text-[14px] duration-200 hover:bg-[#1c076c] hover:no-underline  hover:text-white ${!open && "scale-0"
                        }`}
                    >
                      <li className="flex items-center  buttonn  pl-3  cursor-pointer hover:text-white hover:bg-[#1c076c]">
                        C++ History
                      </li>
                    </a>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;

export const Navbar = ({ open, setOpen, mob, setmob }) => {
  let navs = document.querySelectorAll(".navv");
  console.log(navs);
  navs.forEach((nav) => {
    nav.addEventListener("click", () => {
      reset();
      nav.classList.add("activeNav");
    });
  });

  function reset() {
    navs.forEach((nav) => nav.classList.remove("activeNav"));
  }

  return (
    <div>
      <nav class="bg-[#1c076c] border-gray-200 px-2 sm:px-4 mb-5 fixed z-50 top-[80px] lg:top-[95px] w-full h-12 dark:bg-gray-800">
        <div class=" flex justify-between items-center ">
          <div className="flex text-white w-full">
            <div className="flex  h-12 lg:items-center lg:justify-between lg:px-4 cursor-pointer hover:text-white hover:bg-[#1c076c] mr-3  w-full ">

              <div className="mt-[10px]  translate-y-3 lg:hidden flex animate-bounce lg:animate-none  z-10 ">
                <img
                  src="data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCAxNzIgMTcyIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtbGluZWNhcD0iYnV0dCIgc3Ryb2tlLWxpbmVqb2luPSJtaXRlciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtZGFzaGFycmF5PSIiIHN0cm9rZS1kYXNob2Zmc2V0PSIwIiBmb250LWZhbWlseT0ibm9uZSIgZm9udC13ZWlnaHQ9Im5vbmUiIGZvbnQtc2l6ZT0ibm9uZSIgdGV4dC1hbmNob3I9Im5vbmUiIHN0eWxlPSJtaXgtYmxlbmQtbW9kZTogbm9ybWFsIj48cGF0aCBkPSJNMCwxNzJ2LTE3MmgxNzJ2MTcyeiIgZmlsbD0ibm9uZSI+PC9wYXRoPjxnIGZpbGw9IiNmZmZmZmYiPjxwYXRoIGQ9Ik04Niw2Ljg4Yy00My42MzE1NiwwIC03OS4xMiwzNS40ODg0NCAtNzkuMTIsNzkuMTJjMCw0My42MzE1NiAzNS40ODg0NCw3OS4xMiA3OS4xMiw3OS4xMmM0My42MzE1NiwwIDc5LjEyLC0zNS40ODg0NCA3OS4xMiwtNzkuMTJjMCwtNDMuNjMxNTYgLTM1LjQ4ODQ0LC03OS4xMiAtNzkuMTIsLTc5LjEyek05OC43NTIxOSwxMTcuOTY3ODFjMS4zNDM3NSwxLjM0Mzc1IDEuMzQzNzUsMy41MjA2MiAwLDQuODY0MzdjLTAuNjcxODcsMC42NzE4OCAtMS41NDUzMSwxLjAwNzgxIC0yLjQzMjE5LDEuMDA3ODFjLTAuODg2ODcsMCAtMS43NjAzMSwtMC4zMzU5NCAtMi40MzIxOSwtMS4wMDc4MWwtMzQuNCwtMzQuNGMtMS4zNDM3NSwtMS4zNDM3NSAtMS4zNDM3NSwtMy41MjA2MiAwLC00Ljg2NDM3bDM0LjQsLTM0LjRjMS4zNDM3NSwtMS4zNDM3NSAzLjUyMDYyLC0xLjM0Mzc1IDQuODY0MzcsMGMxLjM0Mzc1LDEuMzQzNzUgMS4zNDM3NSwzLjUyMDYyIDAsNC44NjQzN2wtMzEuOTY3ODEsMzEuOTY3ODF6Ij48L3BhdGg+PC9nPjwvZz48L3N2Zz4="
                  alt=""
                  className={`cursor-pointer hover:text-white hover:bg-[#1c076c]  text-white    duration-300
             ${!open && "rotate-180  duration-300 "}  h-8 w-8`}
                  onClick={() => {
                    setOpen(!open);
                    setmob(!mob);
                  }}
                ></img>
              </div>
              <a href="/javascript-variables" className="text-white">  <div className="hidden lg:flex h-12 navv  items-center hover:bg-white hover:text-black justify-center px-4 cursor-pointer hover:text-white hover:bg-[#1c076c] mr-3  w-full ">
                Javascript
              </div></a>
              <a href="/python-variables" className="text-white">  <div className="hidden lg:flex h-12 navv  items-center hover:bg-white hover:text-black justify-center px-4 cursor-pointer hover:text-white hover:bg-[#1c076c] mr-3  w-full ">
                Python
              </div></a>
              <a href="/c-variable" className="text-white"> <div className="hidden lg:flex h-12  navv items-center hover:bg-white hover:text-black justify-center px-4 cursor-pointer hover:text-white hover:bg-[#1c076c] mr-3  w-full ">
                C
              </div></a>
              <a href="/java-variables" className="text-white"> <div className="hidden lg:flex h-12 navv  items-center hover:bg-white hover:text-black justify-center px-4 cursor-pointer hover:text-white hover:bg-[#1c076c] mr-3  w-full ">
                JAVA
              </div></a>
              <a href="/csharp-first-program" className="text-white"> <div className="hidden lg:flex h-12 navv  items-center hover:bg-white hover:text-black justify-center px-4 cursor-pointer hover:text-white hover:bg-[#1c076c] mr-3  w-full ">
                C#
              </div></a>
              <a href="/php-variables" className="text-white"> <div className="hidden lg:flex h-12 navv  items-center hover:bg-white hover:text-black justify-center px-4 cursor-pointer hover:text-white hover:bg-[#1c076c] mr-3  w-full ">
                PHP
              </div></a>
            </div>


          </div>
        </div>
      </nav>
      <div className="lg:mt-28 mt-20"></div>
    </div>
  );
};
